import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTY_ERROR_CODES = {
  'list': [],
  'loading': false,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'values': {
    'code': '',
    'description': '',
    'status': 'A',
  },
};
export const warrantyErrorCodes = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_ERROR_CODES, {
    [ActionTypes.FETCHING_WARRANTY_ERROR_CODES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_ERROR_CODES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WARRANTY_ERROR_CODES_LIST_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTY_ERROR_CODES_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_WARRANTY_ERROR_CODES,
    }),
  })(state, action);
};

export const errorCodesForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_WARRANTY_ERROR_CODE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_ERROR_CODE]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': action.response.data.code,
        'description': action.response.data.description,
        'status': action.response.data.status,
      },
    }),
    [ActionTypes.FETCHED_WARRANTY_ERROR_CODE_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': '',
        'description': '',
        'status': '',
      },
    }),
    [ActionTypes.CLEAN_WARRANTY_ERROR_CODE]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': '',
        'description': '',
        'status': 'A',
      },
    }),
  })(state, action);
};
